<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" align="center">
        <label :for="id" class="custom-file-upload justify-center v-btn v-size--x-large">
          <v-icon style="margin-right: 5px" dark>
            mdi-folder-play-outline
          </v-icon>{{ $t('VideoInput.Record Video') }}
        </label>
        <input :id="id" type="file" accept="video/*" capture="user" @change="createVideo">
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
    name: "VideoInput",
    props: {
        id: {type: String, default: "Video Upload"}
    },
    data () {
        return {
            videoPresentation: "",
        };
    },
    mounted () {
    },
    methods: {
        createVideo ( e ) {
            const files = e.target.files || e.dataTransfer.files;
            const file = new File([files[0]], "video.mp4", {type: files[0].type, lastModified: new Date()});
            const url = URL.createObjectURL(file);
            this.$emit('videoUploader', file, url); // has video
        },
    }
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: none;
  border-radius: 3px;
  background: rgb(78,200,246);
  background: linear-gradient(0deg, rgba(78,200,246,1) 0%, rgba(4,79,251,1) 57%);
  color: white;
  padding: 15px 50px;
  cursor: pointer;
}

</style>
